package sarka.design.skoria.network

import kotlinx.browser.window

/**
 * Web implementation uses localStorage for token persistence.
 */
actual class TokenStorage {

    actual suspend fun saveToken(token: String) {
        window.localStorage.setItem("skoria_auth_token", token)
    }

    actual suspend fun getToken(): String? {
        return window.localStorage.getItem("skoria_auth_token")
    }

    actual suspend fun saveUsername(username: String) {
        window.localStorage.setItem("skoria_auth_username", username)
    }

    actual suspend fun getUsername(): String? {
        return window.localStorage.getItem("skoria_auth_username")
    }

    actual suspend fun clear() {
        window.localStorage.removeItem("skoria_auth_token")
        window.localStorage.removeItem("skoria_auth_username")
    }
}
